import StudentApis from "../../../api/studentApis";
import { refresh } from "../../../asset";
import CustomButton from "../../../components/CustomButton";
import { Student } from "../../../types/studentType";
import DocumentDetails from "./DocumentDetails";
import FamilyDetails from "./FamilyDetails";
import MedicalDetalis from "./MedicalDetails";
import OtherAdmissionDetails from "./OtherAdmissionDetails";
import StudentAdmissionProfile from "./StudentAdmissionProfile";
import { useRef, useState } from "react";

import { useFormEdit } from "../../../util/hooks/useFormEdit";
import { usePrint } from "../../../util/hooks/usePrint";
import { IS_LIVE } from "../../../util/config/env";

export default function AdmissionDetails({
  studentData,
}: {
  studentData: Student;
}) {
  const [loading, setLoading] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const printRef = useRef<HTMLDivElement | null>(null);

  const form = useFormEdit<Student>(studentData);

  const handleFetch = () => {
    setLoading(true);
    setTimeout(() => {
      setShowDetails(true);
      setLoading(false);
    }, 500);
  };

  const handleUpdate = async () => {
    try {
      setLoading(true);
      await StudentApis.updateStudent(form.formData);
    } catch {
    }
  };

  const handlePrint = usePrint(printRef, {
    documentTitle: "Student_Admission_Form",
  });

  return (
    <div>
      {!showDetails && (
        <div className="flex py-7 justify-center">
          <CustomButton
            text="Fetch all admission data"
            color="bg-success-600"
            icon={refresh}
            onClick={handleFetch}
            iconClassName={loading ? "animate-spin" : ""}
            disabled={loading}
          />
        </div>
      )}

      {showDetails && (
        <>
          <div ref={printRef} className="flex print-section flex-col gap-7 divide-y divide-neutral-50">
            <StudentAdmissionProfile form={form} onPrint={handlePrint} />
            <DocumentDetails form={form} />
            <FamilyDetails form={form} />
            {!IS_LIVE && <MedicalDetalis form={form} />}
            <OtherAdmissionDetails form={form} />
          </div>

          <div className="flex justify-end px-8">
            <CustomButton
              color="bg-primary-500"
              text="Submit Form"
              onClick={handleUpdate}
              disabled={!form.isEditing}
            />
          </div>
        </>
      )}
    </div>
  );
}
